import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
export var useControlledState = function useControlledState(defaultValue, value, onChange) {
  var _useState = useState(value === undefined ? defaultValue : value),
      _useState2 = _slicedToArray(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  var realValue = value === undefined ? internalValue : value;
  var isControlled = value !== undefined;
  var setRealValue = useCallback(function (newValue) {
    if (onChange) {
      onChange(newValue);
    }

    if (value === undefined) {
      setInternalValue(newValue);
    }
  }, [setInternalValue, onChange, value]);
  return [realValue, setRealValue, isControlled];
};